import InfoHeader, { InfoHeaderProps } from './InfoHeader';

export type { InfoHeaderProps };
export default InfoHeader;
